<template>
  <div class="sale-filter d-flex flex-column gap-4">
    <snow-checkboxes-dropdown
      v-model="value.product_id"
      placeholder="Produto"
      id="product-select"
      :options="productOptions"
    />

    <snow-checkboxes-dropdown
      v-model="value.status"
      placeholder="Status"
      id="status-select"
      :options="statuses"
    />

    <snow-checkboxes-dropdown
      v-model="value.payment_method"
      id="payment_method-select"
      placeholder="Método de pagamento"
      :options="paymentMethods"
    />

    <snow-input
      v-model="value.current_install"
      number
      id="current_install"
      label="Número de cobranças"
      :min="0"
    />

    <snow-input
      v-model="value.installments"
      number
      id="installments"
      label="Quantidade de parcelas"
      :min="0"
    />

    <snow-select
      v-model="value.has_coupon"
      label="Cupom"
      :options="[
        { id: '', name: 'Todos' },
        { id: 'has-coupon', name: 'Com Cupom' },
        { id: 'no-coupon', name: 'Sem Cupom' }
      ]"
    />

    <div class="d-flex gap-4">
      <snow-checkbox
        v-model="value.is_upsell"
        isBoolean
        id="upsell"
        name="Upsell"
      />
      <snow-checkbox
        v-model="value.is_order_bump"
        isBoolean
        id="order_bump"
        name="Order Bump"
      />
      <snow-checkbox
        v-model="value.is_trial"
        isBoolean
        id="trial"
        name="Período de teste"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      paymentMethods: [
        { id: "card", label: "1 cartão" },
        { id: "two_card", label: "2 cartões" },
        { id: "billet", label: "Boleto" },
        { id: "pix", label: "Pix" },
        { id: "smart_card", label: "Parcelamento Inteligente (1 Cartão)" }
      ],
      statuses: [
        { id: "paid", label: "Aprovado" },
        { id: "created", label: "Criado" },
        { id: "pending", label: "Pendente" },
        { id: "completed", label: "Completo" },
        { id: "chargeback", label: "Chargeback" },
        { id: "failed", label: "Falha na Cobrança" },
        { id: "reversal", label: "Estorno Automático" },
        {
          id: "reversal_manual",
          label: "Estorno Manual"
        }
      ]
    };
  },
  computed: {
    ...mapState("integration", ["coproducerProducts"]),
    productOptions() {
      return this.coproducerProducts.map(
        ({ product_id: id, product_name: name }) => ({
          id,
          label: name
        })
      );
    }
  }
};
</script>
